<template>
  <div>
    <div class="row">
      <modals-container
        @confirmRemoveDocument="confirmRemoveDocument"
      ></modals-container>

      <div style="border: 1px solid rgba(232, 232, 232, 0.8); padding: 10px">
        <label>{{ $t("message.addDocument") }}:</label>
        <div class="row">
          <div class="col-md-12">
            <table>
              <tr>
                <td>
                  <button
                    @click="$refs.documentInput.click()"
                    class="btn btn-info mr-2"
                  >
                    {{ $t("message.chooseFile") }}
                  </button>
                </td>
                <td>
                  <select v-model="selectedMonth">
                    <option
                      v-for="(month, index) in months"
                      :value="month"
                      :key="index"
                    >
                      {{ removeDayFromDate(month) }}
                    </option>
                  </select>
                </td>
                <td>
                  <select v-model="category">
                    <option value="job">{{ $t("message.job") }}</option>
                    <option value="material">
                      {{ $t("message.material") }}
                    </option>
                    <option value="foreignService">
                      {{ $t("message.foreignService") }}
                    </option>
                    <option value="inventory">
                      {{ $t("message.inventory") }}
                    </option>
                    <option value="additionalCosts">
                      {{ $t("message.additionalCosts") }}
                    </option>
                    <option value="invoice">{{ $t("message.invoice") }}</option>
                    <option value="offer">{{ $t("message.offer") }}</option>
                    <option value="other">{{ $t("message.other") }}</option>
                  </select>
                </td>
                <td>
                  <button @click="upload" class="btn btn-info mr-2">
                    {{ $t("message.upload") }}
                  </button>
                </td>
                <td>
                  <button
                    v-if="fileList.length"
                    @click="cancel"
                    class="btn btn-info mr-2"
                  >
                    {{ $t("message.cancel") }}
                  </button>
                </td>
              </tr>
            </table>
            <ul>
              <li v-for="(file, index) in fileList" :key="index">
                {{ file.name }}
              </li>
            </ul>
          </div>
          <br />
        </div>
        <input
          type="file"
          style="display: none"
          @input="addDocument"
          id="imageInput"
          ref="documentInput"
          multiple
        />
        <br />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="row" v-if="documents.length !== 0">
          <div class="col-md-12">
            <label>{{ $t("message.filterByCategory") }}:</label><br />
            <select v-model="selectedCategory">
              <option value=""></option>
              <option value="job">{{ $t("message.job") }}</option>
              <option value="material">{{ $t("message.material") }}</option>
              <option value="foreignService">
                {{ $t("message.foreignService") }}
              </option>
              <option value="inventory">{{ $t("message.inventory") }}</option>
              <option value="additionalCosts">
                {{ $t("message.additionalCosts") }}
              </option>
              <option value="invoice">{{ $t("message.invoice") }}</option>
              <option value="offer">{{ $t("message.offer") }}</option>
              <option value="other">{{ $t("message.other") }}</option>
            </select>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ $t("message.month") }}</th>
                  <th>{{ $t("message.description") }}</th>
                  <th>{{ $t("message.category") }}</th>
                  <th>{{ $t("message.action") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(document, index) in monthVisibleDocuments" :key="index">
                  <td v-if="!document.previousIsTheSame">
                    {{ document.monthOfAssignment }}
                  </td>
                  <td v-else>
                  </td>
                  <td
                    @mouseover="
                      toolTipTextDocumentSetVisibleUnvisible(true, document.id)
                    "
                    @mouseleave="
                      toolTipTextDocumentSetVisibleUnvisible(false, null)
                    "
                    scope="col"
                  >
                    <i class="fa fa-file" aria-hidden="true"></i>
                    <a :href="document.fileUrl"> {{ document.fileName }}</a>

                    <span
                      v-if="currentDocumentIndex === document.id"
                      class="toolTipTextDocument"
                      v-bind:class="{ visible: showToolTipDocument }"
                    >
                      {{ $t(`message.afterClickingPlsCheck`) }}</span
                    >
                  </td>
                  <td>{{ $t(`message.${document.category}`) }}</td>
                  <td style="text-align: right">
                    <button
                      @click="removeDocument(document.id)"
                      data-toggle="tooltip"
                      data-original-title="Delete"
                      class="btn btn-default btn-xs"
                    >
                      <i data-v-2fbef3e4="" class="fa fa-trash font-8"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OkModal from "../../modals/OkModal";
import DialogModal from "../../modals/DialogModal";

export default {
  data() {
    return {
      currentDocumentIndex: null,
      documents: [],
      months: [],
      selectedCategory: "",
      selectedMonth: null,
      selected: "" || "defaultValue",
      category: "job",
      fileList: [],
    };
  },
  created() {
    this.getTheListOfDocuments();
    this.getStartMonthForDocument();
  },
  methods: {
    confirmRemoveDocument(documentId) {
      let self = this;

      self
        .update(
          this.apiPrefix,
          this.sheetApiUrl + `remove-document/${this.$route.params.id}`,
          "",
          { document_id: documentId }
        )
        .then(() => {
          self.getTheListOfDocuments();
          let msg = self.$t("message.documentSuccesfullyRemoved");
          self.$modal.show(
            OkModal,
            {
              text: msg,
              modalClass: self.modalClasses.okSuccessClass,
            },
            {
              width: self.modalWidth(),
              height: "auto",
            }
          );

          this.documents = [];
        })
        .catch((err) => {
          if (err.response !== undefined) {
            let msg = self.createErrorMessage(
              self.parseErrors(err.response.data)
            );

            self.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okErrorClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
          }
        });
    },
    monthsFromStartDate(startDate) {
      let endDate = this.$moment(startDate).add(36, "M");

      let month = this.$moment(startDate); //clone the startDate
      while (month < endDate) {
        this.months.push(month.format("YYYY-MM-DD"));
        month.add(1, "month");
      }
    },
    getStartMonthForDocument() {
      this.get(this.apiPrefix, this.sheetApiUrl, "", this.$route.params["id"])
        .then((resp) => {
          if (resp.data.start_date !== null) {
            this.selectedMonth = resp.data.start_date;
            this.monthsFromStartDate(resp.data.start_date);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    sendRequestForUploadingOneFile(file) {
      let self = this;

      const fd = new FormData();

      //remove white spaces from file name
      let newFile = new File([file], file.name.split(" ").join(""));

      // add document selected in the event and its name to the FormData object
      fd.append("file", newFile);
      this.update(
        this.apiPrefix,
        this.sheetApiUrl +
          `add-document/${this.$route.params.id}?date_of_assignment=${this.selectedMonth}&category=${this.category}`,
        "",
        fd
      )
        .then(() => {
          this.getTheListOfDocuments();
          this.succesfullyUploadedFiles++;

          if (this.succesfullyUploadedFiles == this.fileList.length) {
            let msg = self.$t("message.documentSuccesfullyUploaded");
            this.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okSuccessClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
            this.fileList = [];
          }
        })
        .catch((err) => {
          if (err.response !== undefined) {
            let msg = self.createErrorMessage(
              self.parseErrors(err.response.data)
            );

            self.$modal.show(
              OkModal,
              {
                text: msg,
                modalClass: self.modalClasses.okErrorClass,
              },
              {
                width: self.modalWidth(),
                height: "auto",
              }
            );
          }
        });
    },
    cancel() {
      this.fileList = [];
    },
    removeDocument(documentId) {
      this.$modal.show(
        DialogModal,
        {
          text: this.$t("message.areYouSureRemove"),
          param: documentId,
          textColor: "#c44133",
          event: "confirmRemoveDocument",
        },
        {
          width: this.modalWidth(),
          height: "auto",
        }
      );
    },

    toolTipTextDocumentSetVisibleUnvisible(visible, documentId) {
      this.showToolTipDocument = visible;
      this.currentDocumentIndex = documentId;
    },
    getTheListOfDocuments() {
      this.getList(
        this.apiPrefix,
        this.sheetApiUrl + `get-document-list/${this.$route.params.id}`
      )
        .then((resp) => {
          this.documents = resp.data.map((row) => ({
            id: row.pk,
            fileUrl: "/media/" + row.fields.file,
            fileName: row.fields.file.slice(21),
            category: row.fields.category,
            monthOfAssignment: row.fields.date_of_assignment.slice(0, 7),
            previousIsTheSame: false
          }));
          // checks if the previous row has the same date
          // (all except first since the first has no previous element)
          for (let i = 1; i < this.documents.length; i++)
            if (
              this.documents[i - 1].monthOfAssignment ===
              this.documents[i].monthOfAssignment
            )
              this.documents[i].previousIsTheSame = true;
        })
        .catch((err) => {
          console.log(err.response);
          this.$modal.show(
            OkModal,
            {
              text: this.$t("message.oopsSomethingWentWrong"),
              modalClass: this.modalClasses.okErrorClass,
            },
            {
              width: this.modalWidth(),
              height: "auto",
            }
          );
        });
    },
    addDocument(event) {
      this.fileList = event.target.files;
    },
    upload() {
      this.succesfullyUploadedFiles = 0;

      // upload files one by one
      for (let i = 0; i < this.fileList.length; i++) {
        this.sendRequestForUploadingOneFile(this.fileList[i]);
      }
    },
  },
  computed: {
    filteredDocuments() {
      return this.documents.filter((document) => {
        const category = document.category;

        // set previousIsTheSame always to false when filtering
        // so monthVisibleDocuments() method could work properly
        document.previousIsTheSame = false

        return category.includes(this.selectedCategory);
      });
    },
    monthVisibleDocuments(){
      let monthVisibleDocuments = this.filteredDocuments

      // checks if the previous row has the same date
      // (all except first since the first has no previous element)
      for (let i = 1; i < monthVisibleDocuments.length; i++) {
          if (
              monthVisibleDocuments[i - 1].monthOfAssignment ===
              monthVisibleDocuments[i].monthOfAssignment
            )
           monthVisibleDocuments[i].previousIsTheSame = true;
          else
           monthVisibleDocuments[i].previousIsTheSame = false;  
      }
            
      return monthVisibleDocuments
    }
  },
};
</script>

<style>
</style>